import { BarDatum, BarSvgProps, BarTooltipProps, ResponsiveBar } from '@nivo/bar';
import { FunctionComponent } from 'react';
import { colors as colorTokens } from '../../../../styles/color-tokens';
interface BarChartProps {
  data: BarDatum[];
  indexBy: string;
  keys: string[];
  colors?: BarSvgProps<BarDatum>['colors'];
  axisBottom?: BarSvgProps<BarDatum>['axisBottom'];
  legends?: BarSvgProps<BarDatum>['legends'];
  groupMode?: 'grouped' | 'stacked';
  tooltip?: FunctionComponent<BarTooltipProps<BarDatum>>;
  defs?: BarSvgProps<BarDatum>['defs'];
  fill?: BarSvgProps<BarDatum>['fill'];
}

export const BarChart = ({ data, indexBy, keys, colors = '#3F98B4', groupMode = 'stacked', ...props }: BarChartProps) => {
  let skipCount = 1;

  function nFormatter(num: number, digits: number) {
    if (skipCount !== 4) {
      skipCount++;
      return '';
    }
    skipCount = 1;
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'k' },
      { value: 1e6, symbol: 'M' },
      { value: 1e9, symbol: 'G' },
      { value: 1e12, symbol: 'T' },
      { value: 1e15, symbol: 'P' },
      { value: 1e18, symbol: 'E' },
    ];
    const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
    const item = lookup.findLast((item) => num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(regexp, '').concat(item.symbol) : '0';
  }

  return (
    <ResponsiveBar
      data={data}
      indexBy={indexBy}
      keys={keys}
      enableLabel={false}
      colors={colors}
      groupMode={groupMode}
      padding={0.3}
      margin={{ bottom: 50, left: 50, right: 20, top: 30 }}
      tooltip={props.tooltip ? props.tooltip : () => null}
      axisLeft={{
        tickSize: 0,
        tickPadding: 10,
        format: (v) => nFormatter(v, 0),
      }}
      axisBottom={{
        tickSize: 0,
        tickPadding: 10,
      }}
      theme={{
        background: colorTokens.background.surface.base,
        axis: {
          ticks: {
            text: { fill: colorTokens.text.primary },
          },
          legend: {
            text: { fill: colorTokens.text.primary },
          },
        },
        grid: {
          line: { stroke: colorTokens.border.default },
        },
        legends: {
          text: {
            fill: colorTokens.text.primary,
          },
        },
      }}
      {...props}
    />
  );
};
